import { useQuery } from "react-query";
import axios from "infra/http";

function useCnaes() {
  return useQuery(
    "/v1/cnae",
    async (): Promise<{ nome: string; id: string }[]> => {
      const res = await axios.get("/v1/cnae");

      return res.data;
    }
  );
}

export default useCnaes;
